<template lang="html">
  <div class="push-item" v-if="show">
    <div class="item-content">
      <h4>发送至 <span @click="close()"></span></h4>
      <empty v-if="channels.filter(i => i.able).length === 0" :msg="'暂无可发布平台'" />
      <ul v-else>
        <li :class="{active: c.selected}" @click="selectChannel(c)" v-for="(c, i) in channels" :key="i" v-if="c.able">
          <div class="item">
            <img :src="c.icon" alt="">
            <p>{{c.title}}</p>
          </div>
        </li>
      </ul>
      <dl class="button">
        <button @click="confirm()">确定</button>
        <button class="exit" @click="close()">取消</button>
      </dl>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'pushBox',
  components: { empty },
  data() {
    return {
      show: false,
      showDeparts: false,
      icons: {
        up: require('@assets/img/common/upward.svg'),
        down: require('@assets/img/common/xiala.svg')
      },
      channels: [
        {
          title: '电视',
          icon: require('@assets/img/common/tv.png'),
          key: 'avid'
        },
        {
          title: 'Knews',
          icon: require('@assets/img/common/news.png'),
          key: 'knews'
        },
        {
          title: '新媒体发布',
          icon: require('@assets/img/common/i.png'),
          key: 'iditor'
        },
        {
          title: '体育',
          icon: require('@assets/img/common/sport.png'),
          key: 'sport'
        },
        {
          title: '体育CMS',
          icon: require('@assets/img/common/sport.png'),
          key: 'sportcms'
        }
      ],
      channel: {},
      publishPromise: null
    }
  },
  methods: {
    open(id) {
      return this.getOptions(id)
      .then(r => {
        this.publishPromise = this.publishPromise || new Promise((resolve, reject) => {
          this.publishResolve = resolve
        })

        const platforms = r
        if (platforms.length === 0) {
          this.resolveResult('')
        } else if (platforms.length === 1) {
          this.resolveResult(platforms[0].key)
        } else {
          this.matchDepart(r)
          this.show = true
        }

        return this.publishPromise
      })
    },
    resolveResult(res) {
      setTimeout(() => {
        this.publishResolve(res)
        this.publishPromise = null
        this.resetPlatform()
        this.show = false
      }, 0)
    },
    close() {
      this.publishResolve('cancel')
      this.publishPromise = null
      this.resetPlatform()
      this.show = false
    },
    resetPlatform() {
      // 重置发送平台
      this.channels.forEach(i => {
        this.$set(i, 'selected', false)
      })
    },
    selectChannel(c) {
      // 选择渠道
      this.$set(c, 'selected', !c.selected)
    },
    confirm() {
      // 确认渠道发送
      const target = this.channels.filter(i => i.selected && i.able).map(j => j.key).join(',')
      if (!target) {
        this.$toast('请选择推送平台')

        return
      }

      this.resolveResult(target)
    },
    matchDepart(list) {
      // 匹配发送平台数据
      list.forEach(i => {
        this.channels.forEach(j => {
          if (i.key === j.key) {
            this.$set(j, 'able', true)
            this.$set(j, 'title', i.title)
            this.$set(j, 'selected', !!i.selected)
          }
        })
      })
    },
    getOptions(id) {
      // 获取选项数据
      return common.myFetch(apis.Rpt_pushlist, {report_id: id})
      .then((r) => {
        if (r) {
          return r.push_platform || []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.push-item {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;

    .item-content {
        min-width: 490px;
        min-height: 320px;
        background: @bg;
        box-shadow: 4px 4px 10px 0 rgba(5,10,15,0.05);
        border-radius: 4px;
        padding: 20px 30px;

        h4 {
            line-height: 30px;
            font-size: 24px;
            color: @dark;

            span {
                display: inline-block;
                width: 22px;
                height: 22px;
                background: url("../assets/img/evaluating/close.svg") no-repeat;
                background-repeat: no-repeat;
                background-position: center;
                cursor: pointer;
                float: right;
                margin-top: 4px;
            }
        }
        ul {
            display: flex;
            margin: 20px 0 60px;
            justify-content: center;
            height: 130px;
            li {
                border: 1px solid @dc;
                border-radius: 6px;
                width: 129px;
                height: 129px;
                margin-right: 19px;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;
                cursor: pointer;
                &::before {
                    content: "";
                    width: 17px;
                    height: 17px;
                    background: rgba(@sub, 0.15);
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    border-radius: 50%;
                }

                &:last-child {
                    margin: 0;
                }

                &.active {
                    border: 1px solid @green;

                    &::before {
                        background: @green url('../assets/img/common/post.svg');
                        background-size: 12px;
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                }
                .item {
                    text-align: center;

                    p {
                        margin-top: 10px;
                        font-size: 14px;
                        color: @sub;
                    }
                }
            }
        }
        .selector {
          height: 30px;
          // margin-top: 40px;
          display: flex;
          align-items: center;
          .title {
            font-size: 14px;
            color: @sub;
            margin-right: 30px;
          }
          .departs {
            flex: 1;
            height: 30px;
            border: 1px solid #dcdcdc;
            border-radius: 4px;
            display: flex;
            padding: 0 20px;
            position: relative;
            .depart {
              flex: 1;
              line-height: 30px;
              font-size: 14px;
              color: @dark;
              cursor: pointer;
            }
            img {
              margin-left: 10px;
              cursor: pointer;
            }
            .list {
              width: 100%;
              position: absolute;
              border-radius: 4px;
              overflow: hidden;
              left: 0;
              margin-top: 10px;
              .boxOuter;
              p {
                padding: 0 20px;
                height: 30px;
                background-color: @bg;
                display: flex;
                justify-content: space-between;
                &:hover {
                  background-color: rgba(185, 195, 195, 0.15);
                }
              }
            }
          }
        }
        .button {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 30px;

            button {
                margin: 0 10px;

                &.exit {
                    background: @dateColor;
                    color: #fff;
                    border: none;
                }
            }
        }
    }
}
</style>
